import './createWithdrawWhitelistForm.scss';

import React from 'react';

interface ICreateWithdrawWhitelistFormProps {
  handleSubmit: () => void;
  children: React.ReactNode;
}

const CreateWithdrawWhitelistForm: React.FC<ICreateWithdrawWhitelistFormProps> = ({
  handleSubmit,
  children,
}) => {
  return (
    <form className="mm-create-withdraw-whitelist-form" onSubmit={handleSubmit}>
      {children}
    </form>
  );
};

export { CreateWithdrawWhitelistForm };
